export default "__VITE_ASSET__BU8Ee7Im__"